import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from '../../profile.service';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  form: UntypedFormGroup = this.fb.group({
    password: ['', [Validators.required]],
    confirmPassword: ['', [Validators.required]],
  }, { validator: this._isPasswordMatchingValidator });

  constructor(private fb: UntypedFormBuilder, private profileService: ProfileService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  onClose() {
    this.closed.emit();
  }

  onSave() { 
    this.profileService.updateUserPassword(this.form.controls['password'].value).subscribe((response) => {
      this.toastr.success("Your password has been changed successfully");
      this.addSuccess.emit();
    }, (err) => {
      if (err && err[0]) {
        this.toastr.error(err[0], 'Error');
      } else {
        this.toastr.error('Unable to change password', 'Error');
      }
    })
  }

  private _isPasswordMatchingValidator(form: UntypedFormGroup) {
    return form.controls['password'].value === form.controls['confirmPassword'].value ? null : { 'mismatch': true };
  }
}
